import React from "react";
import { useSelector } from "react-redux";

import Article from "../Article";

import "./help.less";

const Help = () => {
    const content = useSelector(state => state.content);
    return (
        <div className="help__Main">
            <div className="help__Content">
                {content &&
                    content.map(article => {
                        return <Article key={article.id} {...article} />;
                    })}
            </div>
        </div>
    );
};

export default Help;
